import { useCallback, useEffect, useRef, useState } from "react";

import * as Yup from "yup";

import { FormHandles } from "@unform/core";
import { Form } from "@unform/web";

import Input from "~/components/Input";

import {
  createChatService,
  createMessageService,
  getCategories,
  getHelpChatService,
} from "~/services/deadpool";
import Select from "~/components/Select";
import { useChat } from "~/hooks/chat";
import { CategoriesHelp } from "~/types";

const options = [
  {
    value: 1,
    description: "Suporte",
  },
  {
    value: 2,
    description: "Financeiro",
  },
  {
    value: 3,
    description: "Comercial",
  },
  {
    value: 4,
    description: "Migração",
  },
  {
    value: 5,
    description: "Spam",
  },
  {
    value: 5,
    description: "Insights",
  },
  {
    value: 6,
    description: "Whitelabel",
  },
  {
    value: 1,
    description: "Outros",
  },
];

type HelpBaseProps = {
  setShowOffChat: (value: boolean) => void;
};

const HelpBase: React.FC<HelpBaseProps> = ({ setShowOffChat }) => {
  const [valueSearch, setValueSearch] = useState<string | undefined>(undefined);
  const [valueSelect, setValueSelect] = useState<number>(3);
  const [data, setData] = useState<any>(undefined);

  const [categories, setCategories] = useState<CategoriesHelp[]>();

  const { user, setKeyData, company, setSubmittedTeam } = useChat();

  const formRef = useRef<FormHandles>(null);

  const getHelpChat = useCallback(
    async category => {
      try {
        const { data } = await getHelpChatService({
          per_page: 3,
          categories: category,
        });
        setData(
          data?.map((value: any) => ({
            link: value.link,
            title: value.title.rendered,
          })),
        );
      } catch (e) {
        console.log(e);
      }
    },
    [valueSearch],
  );

  const onSubmitInternal = useCallback(
    async e => {
      try {
        const schema = Yup.object().shape({
          doubt: Yup.string().required("Esse campo é obrigatório"),
          team: Yup.string().required("Esse campo é obrigatório"),
        });
        await schema.validate(e, {
          abortEarly: false,
        });
        formRef.current?.setErrors({});

        const now = new Date();

        if (
          (e.team === "3" && now.getHours() < 9) ||
          (e.team === "3" && now.getHours() >= 18) ||
          (e.team === "3" && now.getDay() === 0) ||
          (e.team === "3" && now.getDay() === 6)
        ) {
          setShowOffChat(true);
        } else if (
          e.team !== "3" &&
          (now.getHours() < 9 ||
            (now.getHours() >= 12 && now.getHours() < 14) ||
            now.getHours() >= 17 ||
            now.getDay() === 0 ||
            now.getDay() === 6)
        ) {
          setShowOffChat(true);
        } else {
          const summary = e?.doubt;

          let payload: any = {
            owner_uuid: user?.uuid,
            owner_name: user?.username,
            owner_email: user?.email,
            is_partner: user?.is_partner,
            company_uuid: company,
            summary,
          };

          const { team } = e;

          payload = {
            ...payload,
            team,
          };

          const { data: dataRes } = await createChatService(payload);

          createMessageService({
            chat_id: dataRes.id,
            text: summary,
            author_uuid: dataRes.owner_uuid,
            author_email: dataRes.owner_email,
            author_name: dataRes.owner_name,
          });
          setKeyData("chat", dataRes);
          setKeyData("createChat", false);
        }
      } catch (e) {
        if (e instanceof Yup.ValidationError) {
          const errorMessages = {} as any;

          e.inner.forEach((error: any) => {
            errorMessages[error.path] = error.message;
          });

          formRef.current?.setErrors(errorMessages);
        }

        console.log(e);
      }
    },
    [user, company],
  );

  const onSubmit = useCallback(
    async data => {
      try {
        const schema = Yup.object().shape({
          doubt: Yup.string().required("Esse campo é obrigatório"),
        });
        await schema.validate(data, {
          abortEarly: false,
        });
        formRef.current?.setErrors({});
        setSubmittedTeam(data.team);
        await getHelpChat(Number(data.categories));
      } catch (e) {
        if (e instanceof Yup.ValidationError) {
          const errorMessages = {} as any;

          e.inner.forEach((error: any) => {
            errorMessages[error.path] = error.message;
          });

          formRef.current?.setErrors(errorMessages);
        }
      }
    },
    [getHelpChat],
  );

  useEffect(() => {
    if (data?.length !== undefined) {
      const fetchHelpBase = async () => {
        await getHelpChat(valueSelect);
      };
      fetchHelpBase();
    }
  }, [valueSelect]);

  useEffect(() => {
    const fetchCategories = async () => {
      const responseCategories = await getCategories();
      setCategories(responseCategories.data);
    };
    fetchCategories();
  }, []);

  return (
    <div className="containerSearch">
      <Form
        style={{
          display: "flex",
          flexDirection: "column",
          minHeight: "390px",
          alignItems: "center",
          justifyContent: "space-between",
        }}
        ref={formRef}
        onSubmit={
          valueSearch !== undefined && data?.length !== undefined
            ? onSubmitInternal
            : onSubmit
        }
      >
        <div className="helpContent">
          <div className="helpForm">
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                width: "100%",
                padding: "20px ",
                gap: "20px",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Select
                value={valueSelect}
                onChange={e => setValueSelect(e.target.value)}
                name="categories"
                label="Como podemos te ajudar?"
              >
                <option disabled value="">
                  Escolha uma área
                </option>
                {categories?.map((category: any) => (
                  <option key={category.id} value={category.id}>
                    {category.name}
                  </option>
                ))}
              </Select>
              <Select
                style={{
                  display: data?.length === undefined ? "flex" : "none",
                }}
                name="team"
                label="Selecione o departamento"
              >
                <option disabled value="">
                  Escolha uma área
                </option>
                {options.map(area => (
                  <option key={area.description} value={area.value}>
                    {area.description}
                  </option>
                ))}
              </Select>
              <Input
                style={{
                  display: data?.length === undefined ? "flex" : "none",
                }}
                isMulti
                minHeight="80px"
                name="doubt"
                value={valueSearch}
                onChange={(e: any) => setValueSearch(e.target.value)}
                placeholder="Acesso ao email"
                label="Descreva aqui a sua dúvida"
              />
            </div>
            {valueSearch !== undefined && data?.length !== undefined ? (
              <div className="helpList">
                {data?.length === 0 ? (
                  <p>
                    Infelizmente não encontramos nenhum artigo para te auxiliar!
                    Para prosseguir com o atendimento, clique no botão abaixo:
                  </p>
                ) : (
                  <>
                    <p>
                      Acreditamos que os artigos abaixos podem te ajudar com o
                      seu problema:
                    </p>

                    <ul className="helperList">
                      {data?.map((item: any) => (
                        <a
                          key={item.link}
                          href={item.link}
                          rel="noreferrer"
                          target="_blank"
                        >
                          <li>{item.title}</li>
                        </a>
                      ))}
                    </ul>
                    <p>Ainda precisa de ajuda?</p>
                  </>
                )}
              </div>
            ) : null}
          </div>
        </div>
        {valueSearch !== undefined && data?.length !== undefined ? (
          <div className="newChat">
            <button style={{ width: "255px", height: "40px" }} type="submit">
              INICIAR ATENDIMENTO
            </button>
          </div>
        ) : null}
        {data?.length === undefined && (
          <button
            style={{ width: "255px", margin: "10px 0 16px 0" }}
            type="submit"
          >
            BUSCAR NA BASE
          </button>
        )}
      </Form>
    </div>
  );
};

export default HelpBase;
